import React from 'react';
import '../less/fin-mon.less';
import FAQStorybook from '@abank/abank-faq';
import advantages_img_1 from '../img/advantages_img_1.png';
import advantages_img_2 from '../img/advantages_img_2.png';
import advantages_img_3 from '../img/advantages_img_3.png';
import advantages_img_4 from '../img/advantages_img_4.png';
import advantages_img_5 from '../img/advantages_img_5.png';
import advantages_img_6 from '../img/advantages_img_6.png';
import advantages_img_7 from '../img/advantages_img_7.png';
import advantages_img_8 from '../img/advantages_img_8.png';
import Advantages from '../../../../../auxiliary-components/shared/AdvantagesBlock';
import QuestionsAdminNew from '../../../../../auxiliary-components/shared/QuestionsAdminNew';
import hero_img from '../img/hero_img.png';
import todo_img from '../img/todo_img.png';
import Hero from '../../../../../auxiliary-components/shared/HeroBlock';
import DOMPurify from 'utils/sanitize';
import { filterByEnvironment } from '../../../../../helpers/utils/environmentFilter';

export default function template() {
  const hero_data = {
    title: 'FINMON_HERO_TITLE',
    text: 'FINMON_HERO_TEXT',
  }

  const advantagesItems = [
    {
      img: advantages_img_1,
      title: 'FINMON_CARDS_ADVANTAGES_TITLE_01',
      text: 'FINMON_CARDS_ADVANTAGES_TEXT_01',
    },
    {
      img: advantages_img_2,
      title: 'FINMON_CARDS_ADVANTAGES_TITLE_02',
      text: 'FINMON_CARDS_ADVANTAGES_TEXT_02',
    },
    {
      img: advantages_img_3,
      title: 'FINMON_CARDS_ADVANTAGES_TITLE_03',
      text: 'FINMON_CARDS_ADVANTAGES_TEXT_03',
    },
    {
      img: advantages_img_4,
      title: 'FINMON_CARDS_ADVANTAGES_TITLE_04',
      text: 'FINMON_CARDS_ADVANTAGES_TEXT_04',
    },
    {
      img: advantages_img_5,
      title: 'FINMON_CARDS_ADVANTAGES_TITLE_05',
      text: 'FINMON_CARDS_ADVANTAGES_TEXT_05',
    },
    {
      img: advantages_img_6,
      title: 'FINMON_CARDS_ADVANTAGES_TITLE_06',
      text: 'FINMON_CARDS_ADVANTAGES_TEXT_06',
    },
    {
      img: advantages_img_7,
      title: 'FINMON_CARDS_ADVANTAGES_TITLE_07',
      text: 'FINMON_CARDS_ADVANTAGES_TEXT_07',
    },
    {
      img: advantages_img_8,
      title: 'FINMON_CARDS_ADVANTAGES_TITLE_08',
      text: 'FINMON_CARDS_ADVANTAGES_TEXT_08',
    }
  ];
  
  const questionsWidget = this.widgetsHelper.getWidget.call(this, 'questions');

  return (
    <div className="finmon">
      <Hero
        data={hero_data}
        img={hero_img}
      />
      <div className="content">
        {!this.state.faqTab ? (
          <>
            <div className="todo">
              <div className="container">
                <h2 className="todo__title">{this.l10n('FINMON_TODO_TITLE')}</h2>
                <div className="todo__body">
                  <img className="todo__image" src={todo_img} alt="todo image" />
                  <div className="todo__text" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(this.l10n('FINMON_TODO_TEXT'))}}></div>
                </div>
              </div>
            </div>
            <Advantages
              items={advantagesItems}
              title={'FINMON_ADVANTAGES_TITLE'}
            />
            <QuestionsAdminNew
              widget={questionsWidget}
              toggleFaqTab={this.toggleFaqTab}
              title={'FAQ_SHORT_NEW_TITLE'}
            />
          </>
        ) : (
          <FAQStorybook
            widget={questionsWidget}
            title={this.l10n('FINMON_FAQ_STORYBOOK_TITLE')}
            btnText={this.l10n('FINMON_FAQ_STORYBOOK_BTN_TEXT')}
            onBtnClick={this.toggleFaqTab}
            filterByEnvironment={filterByEnvironment}
          />
        )}
      </div>
    </div>
  )
}
